<template>
  <div class="barchart-wrap">
    <div class="chart-header">
      <span class="title-text">{{ title }}</span>
      <el-select style="width: 160px" v-model="curField" @change="changeField">
        <el-option label="展示" value="show_cnt"> </el-option>
        <el-option label="点击" value="click_cnt"> </el-option>
        <el-option label="转化" value="convert_cnt"> </el-option>
        <el-option label="消耗" value="cost"> </el-option>
      </el-select>
    </div>
    <div class="chart-content" ref="chartRef"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chart",
  props: {
    title: {
      type: String,
      default: "",
    },
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      curField: "show_cnt",
      myChart: null,
    };
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let chartDom = this.$refs.chartRef;
      let myChart = echarts.init(chartDom);
      window.onresize = myChart.resize;
      this.myChart = myChart;
    },
    formatData() {
      let curfield = this.curField;
      return this.dataList.map((item) => {
        return {
          value: item[curfield],
          name: item.label,
        };
      });
    },
    changeField() {
      if (this.dataList.length === 0) {
        return;
      }
      this.renderData();
    },
    renderData() {
      let data = this.formatData();
      let option = {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            color: [
              "#5470c6",
              "#91cc75",
              "#fac858",
              "#ee6666",
              "#73c0de",
              "#3ba272",
              "#fc8452",
              "#9a60b4",
              "#ea7ccc",
              "#00B2EE",
              "#CD00CD",
              "#00ff66",
              "#FA8072",
            ],
            data: data,
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
    },
  },
  watch: {
    dataList(value) {
      if (value) {
        this.renderData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.barchart-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  width: 100%;
  height: 367px;
  display: flex;
  flex-direction: column;
  .chart-header {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    padding: 24px 24px 0 24px;
    .title-text {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
    }
  }
  .chart-content {
    height: 100%;
  }
}
</style>
